(function () {
  'use strict';
  if (window.ExECreationGuide) return;
  const make = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  function offset() {
    const header = document.querySelector('#header-group, .shopify-section-group-header-group, header-component');
    return Math.max(16, Math.ceil(header?.getBoundingClientRect().height || 0) + 16);
  }
  function focus(target, marker) {
    if (!target) return;
    const top = offset();
    if (marker) marker.style.setProperty('--exe-guide-top', top + 'px');
    const anchor = marker || target;
    anchor.style.scrollMarginTop = top + 'px';
    target.tabIndex = -1;
    target.focus({ preventScroll: true });
    // Measure the marker in normal flow; a sticky marker can already appear
    // at the top while the next panel is still scrolled out of view.
    const position = anchor.style.position;
    if (marker) anchor.style.position = 'static';
    anchor.scrollIntoView({ block: 'start', behavior: 'instant' });
    if (marker) anchor.style.position = position;
  }
  function mount(host, copy, onStep) {
    if (!host || !copy) return null;
    const nav = make('nav', '', 'exe-creation-progress'), status = make('p', '', 'exe-creation-progress__status'), list = make('ol');
    nav.setAttribute('aria-label', copy.steps_label);
    status.setAttribute('aria-live', 'polite');
    nav.append(status, list); host.append(nav);
    const names = [copy.step_reference, copy.step_notes, copy.step_balance, copy.step_order];
    const buttons = names.map((name, index) => {
      const li = make('li'), button = make('button');
      button.type = 'button'; button.dataset.creationStep = index + 1;
      button.append(make('span', String(index + 1), 'exe-creation-progress__number'), make('span', name));
      button.addEventListener('click', () => onStep(index + 1));
      li.append(button); list.append(li); return button;
    });
    function update(current, enabled = [1]) {
      nav.dataset.currentStep = current;
      nav.style.setProperty('--exe-guide-top', offset() + 'px');
      status.textContent = copy.step_status.replace('__step__', current).replace('__name__', names[current - 1]);
      buttons.forEach((button, index) => {
        const number = index + 1;
        button.disabled = number !== current && !enabled.includes(number);
        if (number === current) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
        button.dataset.complete = number < current;
      });
    }
    update(1);
    return { element: nav, update };
  }
  function intro(copy) {
    const panel = make('section', '', 'exe-creation-intro');
    panel.append(make('h2', copy.guide_title), make('p', copy.guide_intro));
    const list = make('ol');
    [copy.detail_reference, copy.detail_notes, copy.detail_balance, copy.detail_order].forEach(text => list.append(make('li', text)));
    panel.append(list); return panel;
  }
  function recommended(notes, inspiration, limit = 8) {
    const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const source = inspiration?.sourceNotes || [];
    const matches = window.ExESearch ? window.ExESearch.plan({ notes: source }, notes).selected : notes.filter(note => source.some(name => [note.name,...(note.aliases||[])].some(alias => normalize(name) === normalize(alias))));
    const matched = new Set(matches.map(note => note.id)), families = new Set(matches.map(note => note.family).filter(Boolean));
    const starting = ['bergamota','sandalo','almizcle','vainilla','cedro','ambar','lavanda','jazmin'];
    return new Set(notes.map((note,index) => ({ note, index, score: matched.has(note.id) ? 1000 : families.has(note.family) ? 100 : starting.includes(note.id) ? 50 - starting.indexOf(note.id) : 0 }))
      .sort((a,b) => b.score-a.score || a.index-b.index).slice(0,limit).map(item => item.note.id));
  }
  function notesPage(all = true) {
    const url = new URL(location.href);
    if (all) url.searchParams.set('notes','all'); else url.searchParams.delete('notes');
    if (document.querySelector('[data-exe-home-creator]')) url.searchParams.set('creation','active');
    url.hash = 'crea-tu-mezcla';
    return url;
  }
  window.ExECreationGuide = { mount, intro, focus, recommended, notesPage };
})();
